import { render, staticRenderFns } from "./ListaCandidatos.vue?vue&type=template&id=9ed9cfe6"
import script from "./ListaCandidatos.vue?vue&type=script&lang=js"
export * from "./ListaCandidatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports